<template>
  <div class="ma-4 px-4">
    <v-row class="my-3">
      <v-col v-if="tab !== 0" cols="12" md="2" class="py-0 my-0">
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="displayDate"
              readonly
              outlined
              label="Date Range"
              dense
              v-bind="attrs"
              v-on="on"
              hide-details="auto"
            ></v-text-field>
          </template>
          <v-sheet
            class="pa-4"
            elevation="4"
            style="background-color: white; border-radius: 8px"
          >
            <v-row no-gutters>
              <v-col>
                <v-date-picker
                  v-model="selectedDates"
                  range
                  @input="onDateChange"
                ></v-date-picker>
              </v-col>
              <v-col class="pl-4 pt-4" style="max-width: 150px">
                <div
                  v-for="option in dateOptions"
                  :key="option.label"
                  class="mb-2 pt-2"
                >
                  <v-btn small color="accent" @click="setQuickDate(option)">
                    {{ option.label }}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-sheet>
        </v-menu>
      </v-col>
      <v-col cols="12" md="2" class="py-0 my-0">
        <v-autocomplete
          v-model="form.program_id"
          :items="programs"
          :item-text="
            (item) =>
              `${item.degree.short_name} ${
                item.specialization ? `- ${item.specialization}` : ''
              }`
          "
          item-value="id"
          outlined
          dense
          clearable
          hide-details="auto"
          label="Programme"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="2" class="py-0 my-0">
        <v-autocomplete
          v-model="form.partner_code"
          :items="partners"
          item-text="name"
          item-value="code"
          outlined
          dense
          clearable
          hide-details="auto"
          label="Partner"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="2" class="py-0 my-0">
        <v-select
          v-model="form.year_batch"
          :items="batches"
          outlined
          dense
          clearable
          hide-details="auto"
          label="Batch"
          @change="getPrograms()"
        ></v-select>
      </v-col>
      <v-col cols="12" md="4" class="py-0 my-0">
        <v-btn
          class="accent white--text"
          :disabled="loading"
          :loading="loading"
          @click="searchFilter()"
        >
          Search
        </v-btn>
        <v-btn
          class="accent white--text ml-2"
          :disabled="!applicants.length"
          :loading="loader"
          @click="download()"
        >
          <v-icon>mdi-download</v-icon> Download
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="d-flex align-center pt-0">
      <v-col cols="10" class="d-flex justify-center pt-0">
        <v-tabs
          v-model="tab"
          class="d-flex justify-center"
          @change="resetFilter()"
        >
          <v-tab key="upload">To Upload</v-tab>
          <v-tab key="validated">UnSuccessfull</v-tab>
          <v-tab key="uploaded">Successfull</v-tab>
        </v-tabs>
      </v-col>
      <v-col cols="2" class="d-flex justify-end">
        <v-btn
          v-if="tab != 2"
          :disabled="!selectedApplicants.length"
          :loading="loading"
          @click="generateUGCDataUpload"
          class="success white--text mr-2"
          >{{ tab === 1 ? "Retry" : "Approve" }}
          {{ selectedApplicants.length ? `(${selectedApplicants.length})` : "" }}</v-btn
        >
      </v-col>
    </v-row>
    <v-dialog v-model="failureDialog" max-width="600">
      <v-card>
        <v-card-title class="text-subtitle-1">
          {{ failedUploads.length }} applicant(s) could not be uploaded
        </v-card-title>
        <v-card-text>
          <v-simple-table dense>
            <thead>
              <tr>
                <th>Application ID</th>
                <th>Reason</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in failedUploads" :key="item.application_id">
                <td>{{ item.application_id }}</td>
                <td>{{ item.error }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="accent" @click="failureDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-tabs-items class="mt-4" v-model="tab">
      <v-tab-item key="upload">
        <v-row>
          <v-col cols="12">
            <v-sheet outlined>
              <v-data-table
                v-model="selectedApplicants"
                :headers="headers"
                :items="applicants"
                fixed-header
                :show-select="true"
                :show-select-all="true"
                :multi-sort="true"
                class="secondary row-height-50"
              >
                <template #[`item.action`]="{ item }">
                  <v-icon small class="mr-2" color="accent" @click="edit(item)">
                    mdi-pencil
                  </v-icon>
                </template>
                <template #[`item.batch`]="{ item }">
                  {{ item.year }} - {{ item.batch }}
                </template>
                <template #[`item.program_id`]="{ item }">
                  {{ getProgramName(item.program_id) }}
                </template>
                <template #[`item.dob`]="{ item }">
                  {{ formatDate(item.dob) }}
                </template>
                <template #[`item.ugc_uploaded_on`]="{ item }">
                  {{ formatDate(item.ugc_uploaded_on) }}
                </template>
                <template #[`item.ugc_attempted_at`]="{ item }">
                  {{ item.ugc_attempted_at || "-" }}
                </template>
                <template #[`item.ugc_reason`]="{ item }">
                  {{ item.ugc_reason || "-" }}
                </template>
                <template #[`item.short_name`]="{ item }">
                  <span
                    @click="navigate(item)"
                    style="
                      cursor: pointer;
                      color: #4f4584;
                      text-decoration: underline;
                    "
                    >{{ item.short_name }}</span
                  >
                </template>
              </v-data-table>
            </v-sheet>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item key="validated">
        <v-row>
          <v-col cols="12">
            <v-sheet outlined>
              <v-data-table
                v-model="selectedApplicants"
                :headers="headers"
                :items="applicants"
                fixed-header
                :show-select="true"
                :show-select-all="true"
                :multi-sort="true"
                class="secondary row-height-50"
              >
                <template #[`item.action`]="{ item }">
                  <v-icon small class="mr-2" color="accent" @click="edit(item)">
                    mdi-pencil
                  </v-icon>
                </template>
                <template #[`item.batch`]="{ item }">
                  {{ item.year }} - {{ item.batch }}
                </template>
                <template #[`item.program_id`]="{ item }">
                  {{ getProgramName(item.program_id) }}
                </template>
                <template #[`item.dob`]="{ item }">
                  {{ formatDate(item.dob) }}
                </template>
                <template #[`item.ugc_uploaded_on`]="{ item }">
                  {{ formatDate(item.ugc_uploaded_on) }}
                </template>
                <template #[`item.ugc_attempted_at`]="{ item }">
                  {{ item.ugc_attempted_at || "-" }}
                </template>
                <template #[`item.ugc_reason`]="{ item }">
                  {{ item.ugc_reason || "-" }}
                </template>
                <template #[`item.short_name`]="{ item }">
                  <span
                    @click="navigate(item)"
                    style="
                      cursor: pointer;
                      color: #4f4584;
                      text-decoration: underline;
                    "
                    >{{ item.short_name }}</span
                  >
                </template>
              </v-data-table>
            </v-sheet>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item key="uploaded">
        <v-row>
          <v-col cols="12">
            <v-sheet outlined>
              <v-data-table
                :headers="headers"
                :items="applicants"
                fixed-header
                class="secondary row-height-50"
              >
                <template #[`item.action`]="{ item }">
                  <v-icon small class="mr-2" color="accent" @click="edit(item)">
                    mdi-pencil
                  </v-icon>
                </template>
                <template #[`item.batch`]="{ item }">
                  {{ item.year }} - {{ item.batch }}
                </template>
                <template #[`item.employee_id`]="{ item }">
                  {{ item.employee_id ? item.employee_id : "-" }}
                </template>
                <template #[`item.program_id`]="{ item }">
                  {{ getProgramName(item.program_id) }}
                </template>
                <template #[`item.dob`]="{ item }">
                  {{ formatDate(item.dob) }}
                </template>
                <template #[`item.ugc_uploaded_on`]="{ item }">
                  {{ formatDate(item.ugc_uploaded_on) }}
                </template>
                <template #[`item.ugc_attempted_at`]="{ item }">
                  {{ item.ugc_attempted_at || "-" }}
                </template>
                <template #[`item.ugc_reason`]="{ item }">
                  {{ item.ugc_reason || "-" }}
                </template>
                <template #[`item.short_name`]="{ item }">
                  <span
                    @click="navigate(item)"
                    style="
                      cursor: pointer;
                      color: #4f4584;
                      text-decoration: underline;
                    "
                    >{{ item.short_name }}</span
                  >
                </template>
              </v-data-table>
            </v-sheet>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { ugcAdmittedApplicantsHeaders } from "@/constants/headers";
export default {
  components: {},
  data() {
    return {
      tab: 0,
      form: {
        program_id: null,
        partner_code: null,
        year_batch: null,
        from_date: null,
        to_date: null,
      },
      // Filters last applied with Search; the list and Download both use these
      appliedFilters: {},
      programs: [],
      partners: [],
      selectedApplicants: [],
      applicants: [],
      fetchRequestId: 0,
      failureDialog: false,
      failedUploads: [],
      loading: false,
      loader: false,
      menu: false,
      selectedDates: [],
      displayDate: "",
      dateOptions: [
        { label: "Today", days: 0 },
        { label: "Yesterday", type: "yesterday" },
        { label: "This Week", type: "week" },
        { label: "Last 7 Days", days: 6 },
        { label: "This Month", type: "month" },
        { label: "Last 30 Days", days: 29 },
        { label: "Reset", type: "reset" },
      ],
      batches: [],
    };
  },
  watch: {},
  computed: {
    // Uploaded On is hidden on every tab; Attempted At and Reason only on the UnSuccessfull tab
    headers() {
      const hidden = ["ugc_uploaded_on"];
      if (this.tab !== 1) hidden.push("ugc_attempted_at", "ugc_reason");
      return ugcAdmittedApplicantsHeaders.filter(
        (header) => !hidden.includes(header.value),
      );
    },
  },
  created() {
    this.$store.commit("setBreadcrumbs", [{ text: "UGC Data Upload" }]);
    this.initialise();
  },
  methods: {
    async initialise() {
      this.getPrograms();
      this.getPartners();
      await this.generateBatchList();
      this.searchFilter();
    },
    buildFilters(form) {
      const { year_batch, ...filters } = form;
      if (year_batch) {
        const [year, batch] = year_batch.split("-");
        filters.year = year;
        filters.batch = batch;
      }
      return Object.fromEntries(
        Object.entries(filters).filter(
          ([, value]) => value !== undefined && value !== null && value !== "",
        ),
      );
    },
    tabFlags() {
      if (this.tab === 1)
        return {
          ugc_data_uploaded: false,
          ugc_data_validated: true,
          ugc_data_verified: false,
        };
      if (this.tab === 2)
        return {
          ugc_data_uploaded: true,
          ugc_data_validated: true,
          ugc_data_verified: true,
        };
      return {
        ugc_data_uploaded: false,
        ugc_data_validated: false,
        ugc_data_verified: false,
      };
    },
    searchFilter() {
      this.appliedFilters = this.buildFilters(this.form);
      this.fetchData();
    },
    resetFilter() {
      this.form.partner_code = null;
      this.form.program_id = null;
      this.form.from_date = null;
      this.form.to_date = null;
      this.selectedDates = [];
      this.displayDate = "";
      this.appliedFilters = {};
      this.form.year_batch = null;
      this.selectedApplicants = [];
      this.fetchData();
    },
    async fetchData() {
      const requestId = ++this.fetchRequestId;
      this.applicants = [];
      await this.$axios
        .get("/get_admitted_applicants", {
          params: { ...this.tabFlags(), ...this.appliedFilters },
        })
        .then((res) => {
          // Ignore stale responses (e.g. tab switched while this request was in flight)
          if (requestId !== this.fetchRequestId) return;
          this.applicants = res.data.data.sort((a, b) =>
            (a.ugc_uploaded_on === null || b.ugc_uploaded_on === null)
              ? 0
              : b.ugc_uploaded_on.localeCompare(a.ugc_uploaded_on),
          );
        })
        .catch(async (error) => {
          console.log(error)
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async generateUGCDataUpload() {
      this.loading = true;
      const application_ids = this.selectedApplicants.map(
        (item) => item.application_id,
      );
      await this.$axios
        .post("/generate_ugc_data_upload", { application_ids: application_ids })
        .then((response) => {
          const { success = [], errors = [] } = response.data.data || {};
          if (errors.length) {
            this.failedUploads = errors;
            this.failureDialog = true;
          }
          this.$store.commit("showSnackbar", {
            message: errors.length
              ? `${success.length} uploaded, ${errors.length} failed`
              : `${success.length} uploaded to UGC successfully`,
            color: errors.length ? (success.length ? "warning" : "error") : "success",
          });
        })
        .catch(async (error) => {
          console.log(error);
          this.$store.commit("showSnackbar", {
            message:
              error.response?.data?.message || "Failed to approve applicants",
            color: "error",
          });
        })
        .finally(() => {
          this.loading = false;
          this.selectedApplicants = [];
          this.fetchData();
        });
    },
    async getPrograms() {
      await this.$axios
        .get("/programs")
        .then((res) => {
          this.programs = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    getProgramName(id) {
      const program = this.programs.find((p) => p.id === id);
      return program
        ? program.degree.short_name +
            (program.specialization ? " - " + program.specialization : "")
        : "";
    },
    async getPartners() {
      try {
        const response = await this.$axios.get("/partners");
        this.partners = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    getPartnerName(code) {
      const partner = this.partners.find((partner) => partner.code === code);
      return partner ? partner.name : "";
    },
    async download() {
      this.loader = true;
      this.$axios
        .get("/download_ugc_data", {
          params: { ...this.tabFlags(), ...this.appliedFilters },
          responseType: "blob",
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: "text/csv" }),
            url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "UGCData.csv");
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit("showSnackbar", {
            message: "Failed to download UGC data",
            color: "error",
          });
        })
        .finally(() => {
          this.loader = false;
        });
    },
    onDateChange() {
      if (this.selectedDates.length === 2) {
        const [fromDate, toDate] = this.selectedDates;
        this.form.from_date = this.formatDateBackend(fromDate);
        this.form.to_date = this.formatDateBackend(toDate);
        this.displayDate = this.formatDisplayDate(fromDate, toDate);
      }
    },
    setQuickDate(option) {
      const today = new Date();
      let fromDate = new Date(today);
      let toDate = new Date(today);

      if (option.type === "reset") {
        this.form.from_date = null;
        this.form.to_date = null;
        this.displayDate = "";
        this.selectedDates = [];
        return;
      }

      if (option.type === "week") {
        fromDate.setDate(today.getDate() - today.getDay());
      } else if (option.type === "month") {
        fromDate.setDate(1);
      } else if (option.type === "yesterday") {
        fromDate.setDate(today.getDate() - 1);
        toDate.setDate(today.getDate() - 1);
      } else if (option.days != null) {
        fromDate.setDate(today.getDate() - option.days);
      }

      this.selectedDates = [fromDate, toDate];
      this.onDateChange();
    },
    formatDateBackend(date) {
      const d = new Date(date);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
        2,
        "0",
      )}-${String(d.getDate()).padStart(2, "0")}`;
    },
    formatDisplayDate(fromDate, toDate) {
      const format = (d) =>
        `${String(d.getDate()).padStart(2, "0")}-${String(
          d.getMonth() + 1,
        ).padStart(2, "0")}-${d.getFullYear()}`;
      return `${format(new Date(fromDate))} ~ ${format(new Date(toDate))}`;
    },
    formatDate(item) {
      if (item) {
        const date = new Date(item);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }
      return "";
    },
    async generateBatchList() {
      try {
        const response = await this.$axios.get("/get_year_batch");
        this.batches = response.data.data;
        this.form.year_batch = this.batches[0];
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.v-data-table::v-deep td {
  font-size: 12px !important;
  padding-right: 0px !important;
}

.v-data-table::v-deep th {
  font-size: 12px !important;
  padding-right: 0px !important;
}
</style>
